import React, { useState, useEffect } from 'react';
import axios from 'axios';
import LaboratoryTable from './laboratory-table';
import TablePagination from '../../common/table-pagination/TablePagination';
import GlobalTableFilter from '../../common/global-table-filter/GlobalTableFilter';
import GlobalDateFilter from '../../common/global-date-filter/global-date-filter.component';
import dateFormat from 'dateformat';
import CustomButton from '../../common/custom-button/custom-button.component';
import * as XLSX from 'xlsx';
import './laboratory.styles.scss';
import { SEARCH_API } from './api';

export default function Laboratory() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [filter, setFilter] = useState(''); // The search term
  const [fromDate, setFromDate] = useState(
    dateFormat(new Date(), 'yyyy-mm-dd')
  );
  const [toDate, setToDate] = useState(dateFormat(new Date(), 'yyyy-mm-dd'));

  const fetchData = async (
    pageIndex = 0,
    pageSize = 20,
    fromDate = dateFormat(new Date(), 'yyyy-mm-dd'),
    toDate = dateFormat(new Date(), 'yyyy-mm-dd')
  ) => {
    setLoading(true);
    try {
      const response = await axios.get(SEARCH_API, {
        params: {
          pageIndex,
          pageSize,
          fromDate,
          toDate,
        },
      });

      const fetchedData = Array.isArray(response.data) ? response.data : [];
      setData(fetchedData);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData(pageIndex, pageSize, fromDate, toDate);
  }, [pageIndex, pageSize, fromDate, toDate]);

  const filteredData = (data || []).filter((row) => {
    const rowDate = new Date(row.date);
    const from = fromDate ? new Date(fromDate) : null;
    const to = toDate ? new Date(toDate) : null;

    // Convert filter input and fields to lowercase for case-insensitive matching
    const searchTerm = filter.toLowerCase();

    // Check if the name or number contains the search term (adjust field names accordingly)
    const matchesSearchTerm =
      (row.name && row.name.toLowerCase().includes(searchTerm)) ||
      (row.number && row.number.toString().includes(searchTerm));

    return (
      matchesSearchTerm && (!from || rowDate >= from) && (!to || rowDate <= to)
    );
  });

  // Filter data based on the filter value
  const filteredData1 = (data || []).filter((row) => {
    if (filter) {
      return Object.values(row).some((value) =>
        String(value).toLowerCase().includes(filter.toLowerCase())
      );
    }
    return true;
  });

  const pageCount = Math.ceil(filteredData.length / pageSize) || 0;
  const pageOptions = Array.from({ length: pageCount }, (_, i) => i);

  const exportToExcel = () => {
    const ws = XLSX.utils.json_to_sheet(filteredData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Laboratory Data');
    XLSX.writeFile(wb, 'laboratory_data.xlsx');
  };

  return (
    <div className='laboratory-table-container'>
      {loading && (
        <div className='spinner-overlay'>
          <div className='spinner' />
        </div>
      )}
      <div className='table-actions'>
        <div className='quick-pay-form-row'>
          <GlobalDateFilter
            label='From :'
            name='fromDate'
            value={fromDate}
            title='From Date'
            handleChange={(date) =>
              setFromDate(date ? date.toISOString().split('T')[0] : '')
            }
            format='dd-MM-yyyy'
            maxDate={new Date()}
            scroll
            required
          />
          <GlobalDateFilter
            label='To :'
            name='toDate'
            value={toDate}
            title='To Date'
            handleChange={(date) =>
              setToDate(date ? date.toISOString().split('T')[0] : '')
            }
            format='dd-MM-yyyy'
            maxDate={new Date()}
            scroll
            required
          />

          {/* Global search filter */}
          <GlobalTableFilter filter={filter} setFilter={setFilter} />

          <div className='button-row'>
            <CustomButton
              onClick={() => {
                // Set both fromDate and toDate to today's date when refresh button is clicked
                const today = dateFormat(new Date(), 'yyyy-mm-dd');
                fetchData(pageIndex, pageSize, fromDate, toDate);
              }}
              disabled={loading}
              type='button'
              className='fetch-data-button'
            >
              {loading ? 'Loading...' : 'Refresh Data'}
            </CustomButton>
          </div>
        </div>
      </div>
      <LaboratoryTable
        data={filteredData1.slice(
          pageIndex * pageSize,
          (pageIndex + 1) * pageSize
        )}
        fetchData={fetchData}
      />
      <TablePagination
        canNextPage={pageIndex < pageCount - 1}
        canPreviousPage={pageIndex > 0}
        pageCount={pageCount}
        pageIndex={pageIndex}
        pageSize={pageSize}
        pageOptions={pageOptions}
        gotoPage={setPageIndex}
        nextPage={() =>
          setPageIndex((prev) => Math.min(prev + 1, pageCount - 1))
        }
        previousPage={() => setPageIndex((prev) => Math.max(prev - 1, 0))}
        setPageSize={setPageSize}
      />
    </div>
  );
}
// //{' '}
//       <div className='header-section'>
//         // <h1>PAP SMEAR</h1>
//         //{' '}
//       </div>
